<!-- 注册弹窗 -->
<template>
  <el-dialog :visible.sync="visible" width="30%" :before-close="handleClose" custom-class="dialog-login">
    <div class="text-center" slot="title">注册</div>
    <el-form :model="form" :rules="rules" ref="form">
      <el-form-item prop="sex" label="性别">
        <el-radio v-model="form.sex" label="1">男</el-radio>
        <el-radio v-model="form.sex" label="2">女</el-radio>
      </el-form-item>
      <el-form-item prop="name">
        <el-input prefix-icon="el-icon-user" placeholder="请输入用户名" v-model="form.name"></el-input>
      </el-form-item>
      <el-form-item prop="email">
        <el-input prefix-icon="el-icon-receiving" placeholder="请输入邮箱" v-model="form.email"></el-input>
      </el-form-item>
      <el-form-item prop="phone">
        <el-input prefix-icon="el-icon-phone-outline" placeholder="请输入手机号" v-model="form.phone"></el-input>
      </el-form-item>
      <el-form-item prop="password">
        <el-input type="password" prefix-icon="el-icon-lock" placeholder="请输入密码" v-model="form.password"></el-input>
      </el-form-item>
      <el-form-item prop="rePassword">
        <el-input
          type="password"
          prefix-icon="el-icon-lock"
          placeholder="请再次输入密码"
          v-model="form.rePassword"
        ></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="submitForm()" style="width: 100%" :disabled="loginButtonDisabled"
        >注 册</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import { EventBus } from '@/utils/eventbus';

export default {
  name: 'DialogRegister',
  props: {
    visible: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      loginButtonDisabled: false,
      form: {
        sex: '1',
        name: '',
        email: '',
        phone: '',
        password: '',
        rePassword: '',
      },
      rules: {
        sex: [{ required: true, message: '请选择性别', trigger: 'blur' }],
        name: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
        email: [
          { required: true, message: '请输入邮箱', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] },
        ],
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^(?:(?:\+|00)86)?1\d{10}$/, message: '请输入正确的手机号', trigger: ['blur', 'change'] },
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, max: 21, message: '密码长度在 6 到 21 个字符', trigger: ['blur', 'change'] },
          {
            pattern: /^(?=.*[0-9])(?=.*[a-zA-Z]).*$/,
            message: '密码必须包含数字和字母',
            trigger: ['blur', 'change'],
          },
        ],
        rePassword: [
          { required: true, message: '请再次输入密码', trigger: 'blur' },
          { min: 6, max: 20, message: '密码长度在 6 到 21 个字符', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (value !== this.form.password) {
                callback(new Error('两次输入密码不一致'));
              } else {
                callback();
              }
            },
            trigger: 'blur',
          },
        ],
      },
    };
  },
  methods: {
    submitForm() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.$store
            .dispatch('register', this.form)
            .then(() => {
              this.$message.success('注册成功，请登录');
              this.$refs['form'].resetFields();
              EventBus.$emit('dialogRegisterVisible', false);
              EventBus.$emit('dialogLoginVisible', true);
            })
            .catch((err) => {});
        }
      });
    },
    handleClose() {
      this.$refs['form'].resetFields();
      EventBus.$emit('dialogRegisterVisible', false);
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .dialog-login {
  padding: 0 30px 10px;
}
</style>
